
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...pageIdArray]",
      function () {
        return require("private-next-pages/[...pageIdArray].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...pageIdArray]"])
      });
    }
  